var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// TODO: more Ramda
import memoize from 'ramda/src/memoize';
import find from 'ramda/src/find';
import map from 'ramda/src/map';
import pipe from 'ramda/src/pipe';
import unless from 'ramda/src/unless';
import identity from 'ramda/src/identity';
import either from 'ramda/src/either';

var prefixes = ['Webkit', 'Moz', 'ms'];

var hasProp = function hasProp(prop) {
  return typeof global.document.documentElement.style[prop] !== 'undefined';
};
var prefixProp = function prefixProp(prop) {
  return function (prefix) {
    return '' + prefix + prop.charAt(0).toUpperCase() + prop.slice(1);
  };
};
var getPrefixedVariants = function getPrefixedVariants(prop) {
  return map(prefixProp(prop))(prefixes);
};
var findPrefixedProp = pipe(getPrefixedVariants, find(hasProp));
var matchProp = unless(hasProp, findPrefixedProp);
var maybeMatchProp = either(matchProp, identity);
var findProp = memoize(maybeMatchProp);

var prefixStyles = function prefixStyles(styles) {
  return Object.keys(styles).reduce(function (result, prop) {
    return _extends({}, result, _defineProperty({}, findProp(prop), styles[prop]));
  }, {});
};

export default prefixStyles;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@lada/prefix/build/browser-esm/index.js
// module id = 460
// module chunks = 0